"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2_SELLER_IDS = exports.EBS_SELLER_ID = exports.DUMMY_SELLER_ID = exports.getLambdaApiBaseUrl = void 0;
function getLambdaApiBaseUrl() {
    if (process.env.INBOUND_SERVICE_URL_V2) {
        return process.env.INBOUND_SERVICE_URL_V2;
    }
    const prodLambdaBaseUrl = "https://inbound.fnd.flexport.com";
    const stagingLambdaBaseUrl = "https://sqjb7w1thl.execute-api.us-east-1.amazonaws.com/staging";
    return process.env.ENV === "staging" ? stagingLambdaBaseUrl : prodLambdaBaseUrl;
}
exports.getLambdaApiBaseUrl = getLambdaApiBaseUrl;
exports.DUMMY_SELLER_ID = "dummy-seller-id";
exports.EBS_SELLER_ID = "flexport-ebs-inbounds-seller-id";
exports.V2_SELLER_IDS = ["owdtest", "owdtestcom", "gweentoysinc"];
//# sourceMappingURL=ClientUtils.js.map